<template>
  <div>
    <b-modal
      id="stripe-terminal"
      title="Take Payment"
      header-bg-variant="dark"
      header-text-variant="light"
      body-bg-variant="light"
      body-text-variant="dark"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      visible
      >
      <div style="justify-content: center;">
        <b-row v-if="useTestData=='true'" style="background:red;"><b-col>TEST CARD READER USED</b-col></b-row>
        <b-row><b-col><b>{{ payment_status }}</b></b-col></b-row>

        <div v-if="showPaymentButtons==true">
          <b-row class="my-3">
            <b-col>{{ error }}</b-col>
          </b-row>
          <b-row class="my-2 mx-5">
            <b-col>
              <b-button class="payment-buttons" block variant="outline-primary" @click="collectPayment()">Collect Payment</b-button>
            </b-col>
            <!-- <b-col>
              <b-button class="payment-buttons" block style="float:right;" variant="outline-success" v-b-modal.cust-tip-modal>Collect Tip</b-button>
            </b-col> -->
          </b-row>
          <b-row>
          </b-row>


        </div>

        <b-row class="my-4" cols="1" v-if="showConfirmButton==true">
          <b-col>
            <b-button variant="outline-primary" @click="capturePayment()">Confirm Payment</b-button>
          </b-col>
        </b-row>
      </div>
      <b-row class="mt-5" cols="2">
        <b-col>
          <b-button variant="primary" @click="backOutFromPayment()">Cancel</b-button>
        </b-col>
        <b-col v-if="showPaymentButtons==true">
          <b-button style="float:right;" variant="outline-primary" @click="discoverCardReaders()">Connect Reader</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <ReaderSelect v-if="this.readers.length>0" :readers="readers"></ReaderSelect>
  </div>
</template>

<script>
import { loadStripeTerminal } from '@stripe/terminal-js';
import ReaderSelect from '@/components/ReaderSelect.vue'

export default {
  name: 'StripeTerminal',
  props: ['payment_intent', 'orderlines', 'order_total', 'tax_total', 'fees', 'customTip', 'order_type'],
  components: {
    ReaderSelect
  },
  data() {
    return {
      payment_status: 'Please wait...',
      intent: {},
      terminal: {},
      readers: {},
      showPaymentButtons: false,
      showConfirmButton: false,
      error: '',
      useTestData: process.env.VUE_APP_TEST_TERMINAL,
    }
  },

  computed: {
    roundedTaxesFees: function() {
      if (this.tax_total || this.fees) {
        const taxes_fees = Number(this.tax_total) + Number(this.fees);
        return Math.round((taxes_fees + Number.EPSILON) * 100);
      } else {
        return 0
      }
    },

    roundedOrderTotal: function() {
      if (this.order_total) {
        return Math.round((Number(this.order_total) + Number.EPSILON) * 100);
      } else {
        return 0
      }
    }


  },

  methods: {
    // Contact the back end to retrieve the token for using Stripe Terminal
    async retrieveTerminalConnectionToken() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      const response = await fetch(process.env.VUE_APP_BASE_URL+'/stripe-terminal-token', {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      const data = await response.json();
      return data.secret;
    },

    // Initialize the Stripe Terminal SDK
    async initializeStripeTerminal() {
      const StripeTerminal = await loadStripeTerminal()
      const terminal = await StripeTerminal.create({
        onFetchConnectionToken: this.retrieveTerminalConnectionToken,
        onUnexpectedReaderDisconnect: this.unexpectedTerminalDisconnect,
      })
      this.$emit('switch-overlay', false);
      this.terminal = terminal;
      this.discoverCardReaders(terminal);
    },

    // If the terminal is disconnected, mid-transaction
    unexpectedTerminalDisconnect() {
      this.payment_status = 'Terminal disconnected unexpectedly. Manually re-connect and try again.';
      this.showPaymentButtons=true;
    },

    discoverCardReaders(terminal) {
      terminal = (!terminal) ? this.terminal : terminal;
      this.showPaymentButtons=false;
      this.payment_status = 'Discovering Terminals...';
      var config = {}
      if (process.env.VUE_APP_TEST_TERMINAL==='true') {
        config = {simulated: true}
      } else {
        config = {simulated: false}
      }
      terminal.discoverReaders(config)
      .then(result => {
        if (result.error) {
          this.payment_status = 'Error during discovery. Please try again.';
          this.showPaymentButtons=true;
          this.error = 'Failed to discover terminals: ' + String(result.error.code) + ' ' + String(result.error.message);
        } else if (result.discoveredReaders.length === 0) {
          this.payment_status = 'No readers associated with Stripe account.';
          this.showPaymentButtons=true;
        // If only one reader, send it to the connectReader function, else pop modal component showing all available readers
      } else if (result.discoveredReaders.length === 1) {
          this.payment_status = 'Reader found';
          this.connectCardReader(terminal, result.discoveredReaders[0]);
        } else {
          this.payment_status = 'Readers found';
        // They're going to need to select a reader
          this.readers = result.discoveredReaders;
          this.$bvModal.show('reader-select-modal');
        }
      })
    },

    connectCardReader(terminal, selectedReader) {
      this.payment_status='Connecting to Terminal...';
      terminal.connectReader(selectedReader, {fail_if_in_use: true})
      .then(result => {
        if (result.error) {
          this.payment_status = 'Unable to connect with Card Reader. Check connection and try again.';
          console.log('Failed to connect: ', result.error);
          this.error = 'Failed to connect to terminal: ' + String(result.error.code) + ' - ' + String(result.error.message);
          this.showPaymentButtons=true;
        } else {
          this.payment_status = 'Connected to reader: ', result.reader.label;
          // console.log('Connected to reader: ', connectResult.reader.label);
          // this.collectPayment(terminal);
          this.setReaderDisplay(terminal);
          // this.showPaymentButtons=true;
        }
      });
    },

    calcLineTotal(orderline) {
      var linetotal = 0;
      linetotal+= orderline.overridden_item_price ? Number(orderline.overridden_item_price) : orderline.std_price;
      for (const option of orderline.options) {
        // find how many options been selected and multiple the price by that amount
        var optqty = option.choiceitems.length;
        linetotal+=(option.add_price*optqty);
        for (const choiceitem of option.choiceitems) {
          linetotal+=(choiceitem.add_price*1);
        }
      }
      linetotal*=orderline.qty;
      return linetotal;
    },

    async setReaderDisplay(terminal) {
      terminal = (!terminal) ? this.terminal : terminal;
      var orderlines = [];
      for (const line of this.orderlines) {
        const name = ('item' in line) ? line.item.name : line.name
        const line_total = ('line_total' in line) ? Number(line.line_total) : await this.calcLineTotal(line)
        const qty = ('quantity' in line) ? line.quantity : line.qty
        orderlines.push(
          {
            "description": name,
            "amount": Math.round((line_total + Number.EPSILON)*100),
            "quantity": qty,
          }
        )
      }
      orderlines.push(
        {
          "description": "Tip",
          "amount": Math.round((this.customTip + Number.EPSILON)*100),
          "quantity": 1,
        }
      )
      const result = await terminal.setReaderDisplay({
        type: 'cart',
        cart: {
          line_items: orderlines,
          tax: this.roundedTaxesFees,
          total: this.roundedOrderTotal,
          currency: 'usd',
        },
      });
      if (result.error) {
        this.payment_status = 'Error - unable to set terminal display';
        this.error = 'Failed to set terminal display: ' + String(result.error.code) + ' - ' + String(result.error.message);
        this.showPaymentButtons=true;
      } else {
        this.showPaymentButtons=true;
        // this.collectPayment(terminal);
      }
    },

    async clearDisplay(terminal) {
      terminal = (!terminal) ? this.terminal : terminal;
      const result = await terminal.clearReaderDisplay()
      if (result.error) {
        this.payment_status = 'Error - unable to clear display';
        this.error = 'Failed to clear terminal display: ' + String(result.error.code) + ' - ' + String(result.error.message);
        this.showPaymentButtons=true;
      }
    },

    async collectPayment(terminal) {
      terminal = (!terminal) ? this.terminal : terminal;
      this.showPaymentButtons=false;
      // this.setReaderDisplay(terminal);
      this.payment_status = 'Ready for payment...';
      // FOR TESTING ONLY
      if (process.env.VUE_APP_TEST_TERMINAL==='true') {
        terminal.setSimulatorConfiguration({testCardNumber: '4242424242424242'});
      }
      // declare clientSecret from paymentIntent (passed back from server)
      var clientSecret = this.payment_intent.clientSecret;
      const result = await terminal.collectPaymentMethod(clientSecret);
      if (result.error) {
        this.payment_status = 'Error - unable to collect payment';
        this.error = 'Failed to collect payment: ' + String(result.error.code) + ' - ' + String(result.error.message);
        this.showPaymentButtons=true;
      } else {
        this.intent = await result.paymentIntent;
        this.processPayment(terminal);
      }
    },

    async processPayment(terminal) {
      this.payment_status = 'Processing payment...';
      const result = await terminal.processPayment(this.intent);
      if (result.error) {
        this.payment_status = 'Unable to process payment';
        console.log(result.error);
        this.error = 'Failed to process payment: ' + String(result.error.code) + ' - ' + String(result.error.message) + ' ('+String(result.error.decline_code)+')';
        this.showPaymentButtons=true;
      } else if (result.paymentIntent) {
        this.intent = await result.paymentIntent;
        // // Finish here for Table orders
        // if (this.order_type==4) {
        //   this.clearDisplay(terminal);
        //   this.$emit('payment-finish', true);
        // } else {
        //   // capture payment NOW
        //   this.capturePayment(terminal);
        // }
        this.capturePayment(terminal);
      }
    },

    async capturePayment(terminal) {
      terminal = (!terminal) ? this.terminal : terminal;
      this.showConfirmButton=false;
      this.payment_status = 'Payment taken by Stripe - awaiting confirmation...';
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();
      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {"paymentintent": this.intent.id}
      // REPLACE CAPTURING THE PAYMENT AT POS TO SIMPLY AUTHORIZING (DONE ABOVE) - NOW UPDATE ORDER / TRANSACTION AND PRINT RECEIPT
      this.$api.post('stripe-terminal-capture', body, config)
      .then(response => {
        if (response.data.paymentIntent.status=="succeeded") {
          this.payment_status = 'Payment confirmed. Redirecting...';
          this.clearDisplay(terminal);
          this.$emit('payment-finish', true);
        } else {
          this.payment_status = 'Error during payment capture. Retry?';
          this.showConfirmButton=true;
          // Handle capture error
        }
      })
      .catch(e => {
       this.payment_status = 'Unable to proceed with payment confirmation';
       console.log(e)
       this.showConfirmButton=true;
      })
    },

    backOutFromPayment() {
        if (this.intent.id) {
          this.$bvModal.msgBoxConfirm("A Stripe Payment - id: "+this.intent.id+" has been created with the customer's card, are you sure you want to exit the transaction?")
          .then(value => {
            if (value==true) {
              // create endpoint for canceling pi
              this.emitCancelPayment()
              // this.$emit('payment-finish', false);
            }
          })
        } else {
          this.emitCancelPayment()
          // this.$emit('payment-finish', false);
        }
    },

    emitCancelPayment() {
      this.clearDisplay();
      this.$emit('payment-finish', false);
    }

  },

  mounted() {
    this.initializeStripeTerminal()
  },
}
</script>

<style>

 .payment-buttons {
   height: 5rem;
   font-size: 140%;
 }

</style>
